import { observer } from 'mobx-react-lite'
import { type SingleSelectFilter } from '@/infra/SingleSelectFilter'
import { match } from '@/utils/pattern-match-util'
import type {
  ScopeChangeRequestStatusFilter,
  ScopeChangeRequestStatusFilterOption,
} from '@/features/admin/scope-change-requests/ScopeChangeRequestsSearchViewModel'
import {
  StatusFilterCards,
  type StatusFilterCardTone,
} from '@/features/admin/components/StatusFilterCards'

export interface ScopeChangeRequestStatusFilterContainerProps<
  TFilters extends Record<string, unknown>,
> {
  filter: SingleSelectFilter<keyof TFilters, ScopeChangeRequestStatusFilter>
}

export const ScopeChangeRequestStatusFilterContainer = observer(
  function ScopeChangeRequestStatusFilterContainer<
    TFilters extends Record<string, unknown>,
  >({ filter }: ScopeChangeRequestStatusFilterContainerProps<TFilters>) {
    return (
      <StatusFilterCards
        title={filter.title}
        selectedKey={filter.value.type}
        options={filter.options.map((opt) => ({
          key: opt.value.type,
          title: opt.title,
          count: opt.value.count,
          tone: statusTone(opt.value.type),
          onSelect: () => filter.change(opt.value),
        }))}
      />
    )
  },
)

function statusTone(
  type: ScopeChangeRequestStatusFilterOption,
): StatusFilterCardTone {
  return match<ScopeChangeRequestStatusFilterOption, StatusFilterCardTone>(
    type,
    {
      all: 'Blue',
      reviewing: 'Blue',
      awaiting: 'Blue',
      accepted: 'Green',
      rejected: 'Red',
    },
  )
}
